import { useEffect, useState } from 'react';
import { getPreferredLanguage } from './languagePreference';

const usePreferredLanguage = () => {
    const [preferredLanguage, setPreferredLanguage] = useState(getPreferredLanguage());

    useEffect(() => {
        const syncPreferredLanguage = () => setPreferredLanguage(getPreferredLanguage());

        window.addEventListener('preferred-language-changed', syncPreferredLanguage);
        window.addEventListener('storage', syncPreferredLanguage);

        return () => {
            window.removeEventListener('preferred-language-changed', syncPreferredLanguage);
            window.removeEventListener('storage', syncPreferredLanguage);
        };
    }, []);

    return preferredLanguage;
};

export default usePreferredLanguage;
